"use client";

import { useInteractions } from "../../../hooks/interactionsProvider";
import StepHeader from "../../ui/stepHeader";
import { VideoInteractionType } from "@yedalabs/schema";
import Answers from "./answers";
import ContinueButton from "../../ui/continueButton";
import AudioInteractionContent from "./audio";
import ClozeInteractionContent from "./cloze";
import MatchInteractionContent from "./match";

export default function AnswersStep() {
    const { selectedInteraction } = useInteractions();

    if (!selectedInteraction) return <></>;

    const copy = getCopy(selectedInteraction.type);

    return (
        <div className="flex flex-col gap-6 w-full">
            <StepHeader
                title={{
                    keyName: copy.title.keyName,
                    defaultValue: copy.title.defaultValue,
                }}
                description={{
                    keyName: copy.description.keyName,
                    defaultValue: copy.description.defaultValue,
                }}
            />

            {selectedInteraction.type === "audio" ? (
                <AudioInteractionContent />
            ) : selectedInteraction.type === "cloze" ? (
                <ClozeInteractionContent />
            ) : selectedInteraction.type === "match" ? (
                <MatchInteractionContent />
            ) : (
                <Answers />
            )}

            <ContinueButton />
        </div>
    );
}

const getCopy = (type: VideoInteractionType) => {
    if (type === "audio") {
        return {
            title: {
                keyName: "interaction-modal.answers-audio.header.title",
                defaultValue: "תוכן",
            },
            description: {
                keyName: "interaction-modal.answers-audio.header.description",
                defaultValue: "הזינו את התוכן לאינטראקציה",
            },
        };
    } else if (type === "cloze") {
        return {
            title: {
                keyName: "interaction-modal.answers-cloze.header.title",
                defaultValue: "טקסט",
            },
            description: {
                keyName: "interaction-modal.answers-cloze.header.description",
                defaultValue:
                    "הזינו את הטקסט, מילה שתרצו שהצופים ישלימו סמנו כך: _כלב_ .",
            },
        };
    } else if (type === "match") {
        return {
            title: {
                keyName: "interaction-modal.answers-match.header.title",
                defaultValue: "קלפים",
            },
            description: {
                keyName: "interaction-modal.answers-match.header.description",
                defaultValue: "הוסיפו את זוגות הקלפים",
            },
        };
    } else {
        return {
            title: {
                keyName: "interaction-modal.answers.header.title",
                defaultValue: "תשובות",
            },
            description: {
                keyName: "interaction-modal.answers.header.description",
                defaultValue: "הזינו את התשובות לשאלה שלכם",
            },
        };
    }
};
